export const HEADER_HEIGHT = 80;
export const HEADER_HEIGHT_MOBILE = 64;

export const HEADER_PADDING_RIGHT = 48;
